<template>
  <a
    :href="props.href"
    :target="props.external ? '_blank' : undefined"
    :rel="props.external ? 'noopener noreferrer' : undefined"
    class="group inline-flex h-[49px] items-center gap-4 rounded-[26px] border-2 border-tw-rust pl-[17px] font-semibold text-tw-ink hover:bg-tw-rust/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tw-rust"
  >
    <span class="leading-8"><slot /></span>
    <span v-if="props.external" class="sr-only">({{ t('newTab') }})</span>
    <span class="flex h-[45px] w-[47px] shrink-0 items-center justify-center rounded-[26px] bg-tw-rust text-2xl text-white" aria-hidden="true"
      >→</span
    >
  </a>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  const props = defineProps({
    href: { type: String, required: true },
    external: { type: Boolean, default: false },
  })

  const { t } = useI18n({
    messages: {
      no: { newTab: 'åpnes i ny fane' },
      en: { newTab: 'opens in a new tab' },
    },
  })
</script>
